import PersonIcon from '@mui/icons-material/AccountCircle'
import AIIcon from '@mui/icons-material/AutoFixNormal'
import CollectionsIcon from '@mui/icons-material/Ballot'
import CommentIcon from '@mui/icons-material/Comment'
import QuotesIcon from '@mui/icons-material/FormatQuote'
import TeamIcon from '@mui/icons-material/Group'
import HomeIcon from '@mui/icons-material/HomeOutlined'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import RadarIcon from '@mui/icons-material/Radar'
import AppsIcon from '@mui/icons-material/Settings'
import CarouselIcon from '@mui/icons-material/ViewCarousel'
import FeaturesIcon from '@mui/icons-material/Widgets'
import LinkStyles from 'components/App/components/AppNavigationSidebar/AppNavigation.pcss'
import { AppNavLink } from 'components/App/components/AppNavigationSidebar/AppNavLink'
import { PPLogo } from 'components/Icons'
import ErrorLogo from 'components/Icons/ErrorLogo'
import { useState } from 'react'
import styles from './AdminNav.pcss'

export function AdminNav({ className }: { className?: string }) {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({})

  const onToggleExpanded = (id: string) => {
    setExpanded(prev => ({ ...prev, [id]: !prev[id] }))
  }

  return (
    <nav className={`${className || ''} ${LinkStyles.expanded}`}>
      <AppNavLink
        label="SUPPORT"
        to="../support"
        id="support"
        expanded={expanded['support'] !== false}
        onToggleExpanded={onToggleExpanded}
        className={styles.parentLink}
        items={(
          <div>
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Users"
              to="../support/users"
              icon={<PersonIcon className={styles['nav-icon']}
              />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Apps"
              to="../support/apps"
              icon={<AppsIcon className={styles['nav-icon']} />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Team Members"
              to="../support/team"
              icon={<TeamIcon className={styles['nav-icon']} />}
            />
          </div>
        )}
      />
      <AppNavLink
        label="BUSINESS"
        to="../business"
        id="business"
        expanded={expanded['business'] !== false}
        onToggleExpanded={onToggleExpanded}
        className={styles.parentLink}
        items={(
          <div>
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Plans"
              to="../business/plans"
              icon={<PPLogo className={`${styles['nav-icon']} ${styles['icon-pp']}`} />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Features"
              to="../business/features"
              icon={<FeaturesIcon className={styles['nav-icon']} />}
            />
          </div>
        )}
      />
      <AppNavLink
        label="ONBOARDING"
        to="../onboarding"
        id="onboarding"
        expanded={expanded['onboarding'] !== false}
        onToggleExpanded={onToggleExpanded}
        className={styles.parentLink}
        items={(
          <div>
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Homepage"
              to="../onboarding/video-training"
              icon={<HomeIcon className={styles['nav-icon']} />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Info boxes"
              to="../onboarding/info-boxes"
              icon={<InfoIcon className={styles['nav-icon']} />}
            />
          </div>
        )}
      />
      <AppNavLink
        label="PRODUCT"
        to="../product"
        id="product"
        expanded={expanded['product'] !== false}
        onToggleExpanded={onToggleExpanded}
        className={styles.parentLink}
        items={(
          <div>
            <AppNavLink
              className={LinkStyles['child-link']}
              label="AI Writer"
              to="../product/writer"
              icon={<AIIcon className={styles['nav-icon']} />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Quotes"
              to="../product/quotes"
              icon={<QuotesIcon className={styles['nav-icon']} />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Post Ideas"
              to="../product/conversation-starters"
              icon={<CommentIcon className={styles['nav-icon']} />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Home Carousels"
              to="../product/home-config"
              icon={<CarouselIcon className={styles['nav-icon']} />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Content Panels"
              to="../product/content-panels"
              icon={<CollectionsIcon className={styles['nav-icon']} />}
            />
          </div>
        )}
      />
      <AppNavLink
        label="LIVE"
        to="../live"
        id="live"
        expanded={expanded['live'] !== false}
        onToggleExpanded={onToggleExpanded}
        className={styles.parentLink}
        items={(
          <div>
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Network Status"
              to="../live/networks-status"
              icon={<RadarIcon className={`${styles['nav-icon']} ${styles['icon-pp']}`} />}
            />
            <AppNavLink
              className={LinkStyles['child-link']}
              label="Post Errors"
              to="../live/errors"
              icon={<ErrorLogo className={`${styles['nav-icon']} ${styles['icon-pp']}`} />}
            />
          </div>
        )}
      />
    </nav>
  )
}
